const Role = {
  Admin: "Admin",
  FieldInspector: "FieldInspector",
  Client:"Client",
  ExternalClient:"External Client"
};
export default Role;
